import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { style: {"white-space":"nowrap"} }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  class: "custom-control custom-switch",
  style: {"margin-left":"0.25rem","margin-right":"0.25rem","display":"inline-block","vertical-align":"middle"}
}
const _hoisted_4 = ["id", "value", "checked", "disabled"]
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.inputId,
      style: _normalizeStyle([{"margin-bottom":"0","user-select":"none","display":"inline-block","vertical-align":"middle"}, {'cursor' : _ctx.disabled ? 'initial':'pointer'}])
    }, [
      (_ctx.isOn)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["text-ok-label", _ctx.disabled ? 'text-disabled':''])
          }, _toDisplayString(_ctx.textOn), 3))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(_ctx.disabled ? 'text-disabled':'')
          }, _toDisplayString(_ctx.textOff), 3))
    ], 12, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: _ctx.inputId,
        type: "checkbox",
        autocomplete: "off",
        value: _ctx.isOn,
        checked: _ctx.isOn,
        class: "custom-control-input",
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        disabled: _ctx.disabled,
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)), ["enter"]))
      }, null, 40, _hoisted_4),
      _createElementVNode("label", {
        class: _normalizeClass(["custom-control-label", _ctx.disabled ? 'disabled':'']),
        for: _ctx.inputId
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "custom-control-label-before" }, null, -1),
        _createElementVNode("span", { class: "custom-control-label-after" }, null, -1)
      ]), 10, _hoisted_5)
    ])
  ]))
}